import React, {useContext} from 'react';
import AddMoneyMuscle from 'components/donate/AddMoneyMuscle';
import AddMoneyHeader from 'components/donate/AddMoneyHeader';
import {UserContext} from 'components/user/UserContext';
import AddMoneyHearth from 'components/donate/AddMoneyHearth';

const AddMoneyPopupWrapper = ({initialAmount = '500', openInNewTab = false}) => {
    const {isCashTenant} = useContext(UserContext);

    return (
        <div data-testid="add-money-popup" style={{overflow: 'hidden'}}>
            <AddMoneyHeader/>
            <div style={{
                padding: '10px',
                margin: '15px',
                fontSize: '20px',
                display: 'flex',
                width: '280px',
                height: isCashTenant ? '75px' : '100px',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                {isCashTenant ? (
                    <AddMoneyMuscle initialAmount={initialAmount} openInNewTab={openInNewTab}/>
                ) : (
                    <AddMoneyHearth/>
                )}
            </div>
        </div>
    );
};
export default AddMoneyPopupWrapper;
